var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFilterUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-StandardActivities",
    transform: "translate(-311.000000, -162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(261.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-filter",
    transform: "translate(50.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    fill: "#EAEAEA",
    points: "0 6.25 6.25 6.25 3.125 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    fill: "#646464",
    transform: "translate(3.125000, 1.875000) rotate(-180.000000) translate(-3.125000, -1.875000) ",
    points: "0 0 6.25 0 3.125 3.75"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterUp);
export default __webpack_public_path__ + "static/media/ic-filter-up.31b64d94ffe4fff9bbe84f402300db95.svg";
export { ForwardRef as ReactComponent };